import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import type { ContractRevision } from '@/types/contract'

export const unsignedContractRevisions = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/contract_revisions/unsigned'
  )
  return Util.Obj.keysToCamel(response.data.contract_revisions) as ContractRevision[]
}
